var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('div',{staticClass:"footer-container"},[_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v("All rights reserved by Fohoway Group.")])])])
}]

export { render, staticRenderFns }